<template>
  <!-- 查看合同页面 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="我的消息" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierInfo" slot="left">
        <yd-navbar-back-icon>个人中心</yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in approveList" :key="index">

      <yd-preview-item style="margin-top:5px;">
        <div slot="left">{{item.dictLabel}}</div>
        <div slot="right" style="position: absolute;right: 0px;">{{item.createDate}}
        </div>
      </yd-preview-item>

      <yd-preview-item v-if="item.approvalContent!=null">
        <div slot="left">驳回原因</div>
        <div slot="right">{{item.approvalContent}}</div>
      </yd-preview-item>
    </yd-preview>
    <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="approveList.length==0">暂无我的消息</yd-preview>
  </div>
</template>
<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  data() {
    return {
      btns:[],
      userId:window.localStorage.getItem("checkUserId"),
      approveList: []
    }
  },
  methods: {
    addContract() {
      this.$dialog.confirm({
        title: '提示',
        mes: '仅需添加当天新办理的合同，按照合同签约审查审批表信息录入！',
        opts: [
          {
            txt: '取消',
            color: false,
            callback: () => {}
          },
          {
            txt: '确定',
            color: true,
            callback: () => {
              this.$router.push({ path: "/supplierAdd",query:{supplierUser:this.supplierUser} });
            }
          }
        ]
      });
    },
    //加载我的消息
    getMyApprove(userId){
      axios({
        method: "get",
        url: baseUrl + "myApprove?userId="+this.userId
      }).then(resp => {
        if (resp.data.error_code == "0") {
          this.approveList = resp.data.data
        }
      })
    }
  },
  mounted() {
    if(!this.userId){
      this.$router.push({ path: "/login"});
    }
    this.getMyApprove();

  }
}
</script>

<style scoped>
.yd-preview-header > :last-child {
  font-size: 0.28rem;
  margin-right: 0.2rem;
}
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-approve.vue